import React from "react";
import { Box } from "@mui/material";

const RefundUponRequestReceipt = ({ orderReport, formatpaymentTime, refundImage }) => {
  const refundInfo = orderReport?.data?.refundDetailInfoList?.[0];
  const items = orderReport?.data?.orderLineItem || [];

  return (
    <>
      <div style={{ marginTop: "5vw" }}>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Box
            component="img"
            src={refundImage}
            alt="Refund Request"
            sx={{ maxHeight: 155, borderRadius: 2, width: "68px", height: "68px" }}
          />
        </Box>

        <h1
          style={{
            color: "#F28618",
            fontSize: "20px",
            fontWeight: "600",
            textAlign: "center",
            marginTop: "2vw",
          }}
        >
          Received your order?
        </h1>
        <div className="refund-box">
          <p style={{fontSize:"12px"}}>Looks like There May Be A Problem With Your Order</p>
        </div>
      </div>

      <div className="rounded-lg p-3 mb-4" style={{  }}>
        <p className="text-gray-800 font-semibold">
          Order : {items.length} Items
        </p>
        <hr style={{ marginTop: "1vw", marginBottom: "2vw" }} />
        <div className="grid grid-cols-3 text-center mt-2 font-medium text-gray-600 text-xs border-gray-300 pb-1">
          <div style={{textAlign:"start"}}>Item(Count)</div>
          <div>Price Per Unit</div>
          <div style={{marginRight:"2vw"}}>Status</div>
        </div>

        {items.map((item, index) => (
          <div
            key={index}
            className="grid grid-cols-3 text-center text-sm mt-1 text-gray-800"
            style={{ fontSize: "10px" }}
          >
            <div style={{textAlign:"start"}}>
              {item.variantName.length > 20
                ? item.variantName.slice(0, 20) + "..."
                : item.variantName}{" "}
              ({String(item.itemQuantity).padStart(2, "0")})
            </div>
            <div>₹ {item.amount}</div>
            <div className="text-red-500 font-medium">
              {item.successQuantity > 0 && (
                <span style={{ color: "#000000B2", fontSize: "10px", fontFamily: "roboto", fontWeight: "700" }}>
                  Success({item.successQuantity})
                </span>
              )}{" "}
              {item.failureQuantity > 0 && (
                <span style={{ color: "#E65C5C", fontSize: "10px", fontFamily: "roboto", fontWeight: "700" }}>
                  Failed({item.failureQuantity})
                </span>
              )}{" "}
              {item.vendRemaining > 0 && (
                <span style={{ color: "#F28618", fontSize: "10px", fontFamily: "roboto", fontWeight: "700" }}>
                  Pending({item.vendRemaining})
                </span>
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="rounded-lg p-3" style={{  }}>
        <p className="text-gray-800 font-semibold">
          Paid Amount : ₹ {refundInfo?.paidAmount}
        </p>
        <hr style={{ marginTop: "1vw", marginBottom: "2vw" }} />
        <p className="text-xs text-gray-600 mt-1" style={{ fontSize: "10px", color: "#000000B2", fontWeight: "400" }}>
          {formatpaymentTime}
        </p>
        <p className="text-xs text-gray-600" style={{ fontSize: "10px", color: "#000000B2", fontWeight: "400" }}>
          Transaction ID: {refundInfo?.transactionId}
        </p>
        <p className="text-xs text-gray-600 mt-2" style={{ fontSize: "10px", color: "#000000B2", fontWeight: "400" }}>
          Payment Method: <span className="font-medium">{refundInfo?.payMethod}</span>
        </p>
      </div>
      <hr/>
    </>
  );
};

export default RefundUponRequestReceipt;
